import { Pipe, PipeTransform } from '@angular/core';
import { CustomValidators } from '../shared/utility/custom-validator';

@Pipe({
  name: 'countryName'
})
export class countryName implements PipeTransform {
    transform(value:any): any {
        switch(value) {
            case 'en':
              return CustomValidators.translationService.instant('language.english')
             case 
             'fi': {
              return CustomValidators.translationService.instant('language.suomi')
            }
            case 'no': {
              return CustomValidators.translationService.instant('language.norsk')
             }
             case 'sv': {
              return CustomValidators.translationService.instant('language.svenska')
             }
             case 'de': {
              return CustomValidators.translationService.instant('language.deutsch')
            }
            case 'ja': {
               return CustomValidators.translationService.instant('language.japanese');
            }
            case 'cd': {
              return CustomValidators.translationService.instant('language.canada')
            }
            case 'nz': {
              return CustomValidators.translationService.instant('language.newzealand')
            }
            case 'fr': {
            return CustomValidators.translationService.instant('language.french');
            }
            case 
             'ko': {
              return CustomValidators.translationService.instant('language.korean');
            }
            case 
             'nb': {
              return CustomValidators.translationService.instant('language.bokmal');
            }
            case 'nn': {
             return CustomValidators.translationService.instant('language.nynorsk');
            } 
            case 'pl': {
              return CustomValidators.translationService.instant('language.polski');
             } 
             case 'nl': {
              return CustomValidators.translationService.instant('language.dutch');
             } 
             case 'bu': {
              return CustomValidators.translationService.instant('language.dutch_be');
             } 
             case 'in': {
              return CustomValidators.translationService.instant('language.india');
             } 
             case 'et': {
              return CustomValidators.translationService.instant('language.estonia');
             } 
             case 'hu': {
              return CustomValidators.translationService.instant('language.hungary');
             } 
            default: {
              return CustomValidators.translationService.instant('language.english')
            }
         }
        //return value;
    }
}
